import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/questions', parameters);
    }

    async getAll(params = {}) {
        return this.submit('get', '/all', params);
    }

    update(id, params) {
        params.append('_method', 'PUT');
        return this.submit('post', `/${id}`, params);
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/Question.js